import { render, staticRenderFns } from "./StoriesSticker.vue?vue&type=template&id=e5c3abea&"
import script from "./StoriesSticker.vue?vue&type=script&lang=js&"
export * from "./StoriesSticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports